import React, { FC } from 'react';
import { PageContainer, Title, faBuilding } from '@/ui/components';
import { useTranslate } from '@/translations';
import { PTSDataGrid } from '@/modules/PTS/components';
import { Card } from 'antd';

export const PTS: FC = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('pts')} icon={faBuilding} />
      <Card>
        <PTSDataGrid />
      </Card>
    </PageContainer>
  );
};
